import React from 'react';
import moment from 'moment';

export default function PostPreviewText({ post, headingClass = '', infoClass = '', className = '', hideAuthor = false, customCategory=false }) {
  if (!post) return null;

  const category = customCategory || post?.content?.category?.name;
  const categoryUrl = post?.content?.category?.full_slug;
  let author = post?.content?.author;
  if (post?.content?.postAuthor) {
    author = post?.content?.postAuthor?.name || post?.content?.postAuthor[0]?.name || post?.content?.author;
  }
  const title = post?.name;
  const date = post?.published_at;
  const formattedDate = date.length > 18 ? moment(date).format('MMMM d, YYYY') : date;

  return (
    <div className={className}>
      <div className="flex-auto">
        {(category && categoryUrl) && <h5 className="mt-2 mb-2 font-bold tracking-normal uppercase text-15px"><div className="transition-colors duration-150 ease-in-out hover:text-blue"> {category}</div></h5>}
        <h3
          className={`text-24px md:text-20px font-heading font-bold mb-3 opacity-90 ${headingClass}`}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
      <div className={`opacity-60 tracking-normal flex space-x-3 ${infoClass}`} >

        {author?.length > 0 && !hideAuthor && (
          <div className="font-bold uppercase font-heading text-13px" dangerouslySetInnerHTML={{ __html: 'By ' + author }} />
        )}
        <div className="text-14px" dangerouslySetInnerHTML={{ __html: formattedDate }} />
      </div>
    </div>
  );
}
